import { useReducer, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";
import countryList from "../data/countries";
import { initialState, reducer } from "../reducers";
const { registrationDetails, attendanceOptions } = require("../data");

const countries = countryList.map(({ name }) => name);

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const requiredFields = [
  "firstname",
  "surname",
  "emailAddress",
  //   "country",
  //   "wantCertificateOfParticipation",
  "attendanceOption",
  //   "studentLevel",
  //   "organization",
  "gender",
  //   "careerStatus",
];

const useYPYC = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { themeContext, theme } = useTheme();
  const {
    selectedLoyaltyData,
    registerYPYC,
    ypycStatus,
    setYPYCStatus,
    checkYPYCRegistrationStatus,
    ypycRegistrationStatus,
  } = useLoyalty();
  const { promoData: { bannerImage, tailImage } = {} } =
    selectedLoyaltyData || {};
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [token, setToken] = useState(null);

  const handleChange = (key, value) => {
    const payload = {};
    let updatedErrors;
    const { errors } = state;
    if (requiredFields.includes(key)) {
      if (!value || value?.trim() === "") {
        updatedErrors = errors.includes(key) ? errors : [...errors, key];
      } else {
        // Remove from errors
        updatedErrors = errors.includes(key)
          ? errors.filter((err) => err != key)
          : errors;
      }
      payload["errors"] = updatedErrors;
    }
    payload[key] = value;
    dispatch({
      type: "update",
      payload,
    });
  };

  const validateForm = () => {
    let updatedErrors = [];
    requiredFields.forEach((key) => {
      if (key === "studentLevel" && state[key] === "Others") {
        if (
          !state["otherStudentLevel"] ||
          state["otherStudentLevel"]?.trim() === ""
        ) {
          updatedErrors.push("otherStudentLevel");
        }
      } else if (
        (key === "emailAddress" && !validateEmail(state[key])) ||
        !state[key] ||
        state[key]?.trim() === ""
      ) {
        updatedErrors.push(key);
      }
    });
    dispatch({
      type: "update",
      payload: {
        errors: updatedErrors,
      },
    });
    return updatedErrors < 1;
  };

  const submitForm = () => {
    if (validateForm) {
      registerYPYC(state);
    }
  };

  useEffect(() => {
    if (ypycRegistrationStatus === null) {
      checkYPYCRegistrationStatus();
    }
  }, [ypycRegistrationStatus]);

  useEffect(() => {
    const t = JSON.parse(localStorage.getItem("token"));
    setToken(t);
  }, []);

  return {
    background,
    history,
    bannerImage,
    tailImage,
    registrationDetails,
    attendanceOptions,
    state,
    handleChange,
    submitForm,
    ypycStatus,
    ypycRegistrationStatus,
    setYPYCStatus,
    validateForm,
    countries,
    token,
  };
};

export default useYPYC;
